var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78822 2.01061C8.20489 1.94063 8.59896 2.22427 8.66841 2.64414L9.60239 7.29105C10.7147 7.90039 12.0621 8.38523 14.3892 7.25932L15.3179 2.64414C15.3874 2.22427 15.7815 1.94063 16.1981 2.01061C16.6148 2.08058 16.8963 2.47768 16.8268 2.89755L15.8261 7.94793C16.2478 8.36363 16.8106 8.7471 17.4945 8.89731C17.8089 8.96635 18.0531 9.26088 17.99 9.57883L17.6054 11.5167C17.467 12.214 17.0348 13.0902 17 14V21C17 21.5523 16.5523 22 16 22H8.15951C7.60723 22 7.15951 21.5523 7.15951 21V14C7.12624 12.8918 6.49847 11.7943 6.31244 10.9508L6.01225 9.58952C5.94148 9.26864 6.1868 8.96584 6.5052 8.89433C7.18312 8.74209 7.74132 8.36092 8.16023 7.94793L7.15951 2.89755C7.09007 2.47768 7.37155 2.08058 7.78822 2.01061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt4);
export default __webpack_public_path__ + "static/media/shirt-4.1008c827431657444c3677d561bc427c.svg";
export { ForwardRef as ReactComponent };